import { render, staticRenderFns } from "./Subtitle1.vue?vue&type=template&id=7950b144&scoped=true&"
import script from "./Subtitle1.vue?vue&type=script&lang=js&"
export * from "./Subtitle1.vue?vue&type=script&lang=js&"
import style0 from "./Subtitle1.vue?vue&type=style&index=0&id=7950b144&scoped=true&lang=css&"
import style1 from "./Subtitle1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7950b144",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
